export enum UserRolesEnum {
  USER = 'user',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  QTY_DISCOUNT_MANAGER = 'qty_discount_manager',
}
